import React, { useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MezzanineProvider } from '../context/MezzanineContext';
import LiveMonitor from '../components/mezzanine/LiveMonitor';
import Deployments from '../components/mezzanine/Deployments';
import ProgramGroups from '../components/mezzanine/ProgramGroups';
import Profiles from '../components/mezzanine/Profiles';
import TxChains from '../components/mezzanine/TxChains';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

function Mezzanine() {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <MezzanineProvider>
      <div className={classes.root}>
        <Tabs value={activeTab} onChange={handleTabChange} className={classes.tabs}>
          <Tab label="Live Monitor" />
          <Tab label="Deployments" />
          <Tab label="Program Groups" />
          <Tab label="Profiles" />
          <Tab label="TX Chains" />
        </Tabs>

        {activeTab === 0 && <LiveMonitor />}
        {activeTab === 1 && <Deployments />}
        {activeTab === 2 && <ProgramGroups />}
        {activeTab === 3 && <Profiles />}
        {activeTab === 4 && <TxChains />}
      </div>
    </MezzanineProvider>
  );
}

export default Mezzanine;
